import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { CustomerTicket } from "../../../types/support";

export const postRequestTechnicalSupport = async (
  namespace: string,
  payload: CustomerTicket,
  context_query_datasource?: string | null,
  context_query_events?: string[] | null,
) => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const params = {
      context_query_events: context_query_events ?? null,
    };

    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/tickets`,
      { ...payload, source_id: context_query_datasource ?? null },
      { headers, params },
    );

    return response?.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to submit technical support request. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while submitting technical support request.",
      );
    }
  }
};
